import React from 'react';
import PropTypes from 'prop-types';
import ReactionTransferTo from '@Components/Results/reactions/ReactionTransferTo';

function ReactionViewConnector({ icon, displayTransferTo, transferToClick }) {
  return (
    <span className={`reactions-item-connector reactions-item-connector--${icon}`}>
      {displayTransferTo ? <ReactionTransferTo onClick={transferToClick} /> : null}
      <svg className="svg-icon svg-icon--medium" aria-label={`reactions-item-connector-${icon}`}>
        <use xlinkHref={`#icon-${icon}`} />
      </svg>
    </span>
  );
}

ReactionViewConnector.defaultProps = {
  displayTransferTo: false,
};

ReactionViewConnector.propTypes = {
  icon: PropTypes.string.isRequired,
  displayTransferTo: PropTypes.bool,
  transferToClick: PropTypes.func,
};

export default ReactionViewConnector;
